<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  beforeMount() {
    if (this.form.widgets === undefined) {
      this.$set(this.form, 'widgets', [])
    }
    if (this.form.text_on_button_pl === undefined) {
      this.$set(this.form, 'text_on_button_pl', '')
    }
    if (this.form.text_on_button_en === undefined) {
      this.$set(this.form, 'text_on_button_en', '')
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Switch({
              label: 'Sekcja prywatna',
              modelPath: [this, 'form', 'is_private']
            }),
            new fields.Input({
              label: 'Tekst na przycisku',
              modelPath: [this, 'form', 'text_on_button'],
              multilingual: true,
              required: true,
              condition: !!this.form.is_private
            }),
            new fields.Header({
              text: 'Elementy sekcji',
              type: 'h3'
            }),
            new fields.Widgets({
              modelPath: [this, 'form', 'widgets'],
              hiddenWidgets: ['SectionWidget']
            })
          ]
        }
      ]
    }
  }
}
</script>
